const angular = require('angular');

const { headerComponentDefinition } = require('./header.component');
const { corporateHeaderComponentDefinition } = require('./corporate-header.component');
const { coreHeaderComponentDefinition } = require('./core-header.component');
const { coreHeaderNavComponentDefinition } = require('./core-header-nav.component');
const { headerSearchComponentDefinition } = require('./header-search.component');
const { headerCheckoutComponentDefinition } = require('./header-checkout.component');
const { headerSkipLinksComponentDefinition } = require('./header-skip-links.component');
const { categoryHeaderComponentDefinition } = require('./category-header.component');
const { categoryHeaderSmallFormatComponentDefinition } = require('./category-header-small-format.component');
const { categoryHeaderBannersComponentDefinition } = require('./category-header-banners.component');

angular.module('wowApp.shop')
    .component('wowHeader', headerComponentDefinition)
    .component('wowCorporateHeader', corporateHeaderComponentDefinition)
    .component('wowCoreHeader', coreHeaderComponentDefinition)
    .component('wowCoreHeaderNav', coreHeaderNavComponentDefinition)
    .component('wowHeaderSearch', headerSearchComponentDefinition)
    .component('wowHeaderCheckout', headerCheckoutComponentDefinition)
    .component('wowHeaderSkipLinks', headerSkipLinksComponentDefinition)
    .component('wowCategoryHeader', categoryHeaderComponentDefinition)
    .component('wowCategoryHeaderSmallFormat', categoryHeaderSmallFormatComponentDefinition)
    .component('wowCategoryHeaderBanners', categoryHeaderBannersComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/header/index.js